import styled, { DefaultTheme } from 'styled-components';
import { Button } from 'antd';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const dark = (props: { theme?: DefaultTheme }, darkVal: string, lightVal: string): string =>
  props.theme?.mode === 'dark' ? darkVal : lightVal;

export const PageWrapper = styled.div`
  padding: 24px;
  max-width: 800px;
`;

export const PageTitle = styled.h1`
  margin: 0 0 32px 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: ${(p) => dark(p, '#f7fafc', '#1a202c')};
  letter-spacing: -0.02em;
`;

export const SectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const SectionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SectionContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SectionTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${(p) => dark(p, '#f7fafc', '#2d3748')};
  margin-bottom: 4px;
`;

export const SectionDescription = styled.div`
  font-size: 0.875rem;
  color: ${(p) => dark(p, '#a0aec0', '#718096')};
  line-height: 1.5;
`;

export const SectionButton = styled(Button)`
  min-width: 140px;
  border-radius: 8px;
  font-weight: 500;

  &.ant-btn-default {
    background: ${(p) => dark(p, '#2d3748', '#1a202c')};
    border-color: ${(p) => dark(p, '#2d3748', '#1a202c')};
    color: #fff;
  }
  &.ant-btn-default:hover {
    background: ${(p) => dark(p, '#4a5568', '#2d3748')};
    border-color: ${(p) => dark(p, '#4a5568', '#2d3748')};
    color: #fff;
  }

  @media (max-width: 640px) {
    width: 100%;
  }
`;
